const postSettingsWarnings = ({
  shouldWarnBlogOnPagebuilderDomainIncompatibilityWithProduct
}) => {
  const warnings = {};
  if (shouldWarnBlogOnPagebuilderDomainIncompatibilityWithProduct) {
    warnings.isBlogOnPagebuilderDomainWithAdvancedAccess = {
      pane: 'settings',
      type: 'isBlogOnPagebuilderDomainWithAdvancedAccess',
      target: 'slug'
    };
  }
  return warnings;
};
export default postSettingsWarnings;